module.exports = __webpack_public_path__ + "media/site/images/banners/banner-contact-tablet-0244996c2a0b48bf4767df1eb82c7d5e.png";